import Vue from 'vue'
import Vuex from 'vuex'
import vuexPersist from 'vuex-persist'

Vue.use(Vuex);

const vuexPersistence = new vuexPersist({
  key: 'tasks-store',
  storage: window.localStorage
});

export default new Vuex.Store({
  state: {
    tasks: []
  },
  mutations: {
    addTask(store, task) {
      store.tasks.push(task);
    },
    removeTask(store, task) {
      this.state.tasks.remove(task)
    },
    modifyTask(store, task) {
      store.tasks.find(item => item.id === task.id).isCompleted = !task.isCompleted;
    },
    reset(store) {
      store.tasks = [];
    }
  },
  actions: {
  },
  modules: {
  },
  getters: {
    completed: state => state.tasks.filter(task => task.isCompleted),
    notCompleted: state => state.tasks.filter(task => !task.isCompleted)
  },
  plugins: [vuexPersistence.plugin]
});
